import {AuthService} from '@/services/AuthService';
import {getToken, setToken, removeToken, getEmail, setEmail, removeEmail} from '@/utils/auth';

const user = {
    namespaced: true,
    state: {
        token: getToken(),
        email: getEmail(),
        user: null,
    },

    mutations: {
        SET_TOKEN: (state, token) => {
            state.token = token;
        },
        RESET: (state) => {
            state.token = '';
            state.user = null;
            removeToken();
            removeEmail();
        },
        SET_USER: (state, user) => {
            state.user = user;
        },
    },

    actions: {
        Login({commit}, userInfo) {
            const username = userInfo.username.trim();
            return new Promise((resolve, reject) => {
                AuthService.login(username, userInfo.password).then(response => {
                    const data = response.data;
                    setToken(data.token);
                    setEmail(data.email);
                    commit('SET_USER', data);
                    commit('SET_TOKEN', data.token);
                    resolve(data.token);
                }).catch(error => {
                    reject(error);
                })
            })
        },

        Refresh({commit, state}) {
            return new Promise((resolve, reject) => {
                AuthService.refreshToken(state.token, state.email).then(response => {
                    const data = response.data;
                    setToken(data.token);
                    setEmail(data.email);
                    commit('SET_TOKEN', data.token);
                    commit('SET_USER', data);
                    resolve();
                }).catch(error => {
                    commit('RESET');
                    reject(error);
                })
            })
        },

        LogOut({commit, state}) {
            return new Promise((resolve) => {
                AuthService.logout(state.token).then(() => {
                    commit('RESET');
                    resolve();
                }).catch(() => {
                    commit('RESET');
                    resolve();
                })
            })
        },

        LogOutNoAuth({commit}) {
            return new Promise((resolve) => {
                commit('RESET')
                resolve()
            })
        }
    }
}

export default user
